import {
  MimaButton,
  MimaText,
  Modal,
  MimaTextArea,
  MimaDropdown,
} from "../../components";
import { Formik } from "formik";
import React from "react";

const IgnorePayout = ({ closeModal, validationSchema, onSubmit, loading }) => {
  return (
    <Modal closeModal={closeModal} goBack={closeModal}>
      <MimaText align="center" mb={2} width={38}>
        Ignore Payout
      </MimaText>

      <Formik
        initialValues={{
          status: "",
          comment: "",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          handleSubmit,
          handleChange,
          setFieldValue,
          handleBlur,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaDropdown
              labelTitle="Status"
              placeholder="Select Status"
              name="status"
              value={values.status}
              id="status"
              data={[
                { value: "IGNORED", key: "IGNORED" },
                { value: "PENDING", key: "PENDING" },
              ]}
              onChange={(data) => {
                setFieldValue("status", data.key);
              }}
            />
            <MimaTextArea
              type="textarea"
              labelTitle="Comment"
              placeholder="Enter Comment"
              name="comment"
              mb={2}
              variant="message"
              error={errors.comment}
              touched={touched.comment}
              value={values.comment}
              onChange={handleChange}
              onBlur={handleBlur}
            />

            <MimaButton
              title="Submit"
              onClick={handleSubmit}
              type="submit"
              loading={loading}
              mt={2}
              width={38}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default IgnorePayout;
